import React, {Component, PropTypes} from 'react'

const BOLD_REGEX = /\*\*(.*)\*\*/

class Markdown extends Component {
    static propTypes = {
        markdown: PropTypes.string.isRequired
    }

    render() {
        const {markdown} = this.props

        const markdownChunks = markdown && markdown.replace(/(\\r)?\\n/g, '\n').split(/\r?\n/) || []

        const print = (chunk) => {
            var matcher

            if (matcher = chunk.match(BOLD_REGEX)) {
                return (<b>{matcher[1]}</b>)
            }
            return chunk || '\u00a0'
        }

        return (
            <div>
                {markdownChunks.map((chunk, index) => (
                    <p key={index}>{print(chunk)}</p>
                ))}
            </div>
        )
    }
}

export default Markdown


// WEBPACK FOOTER //
// ./lib/core/components/Markdown.js